<template>
  <div class="menu-group-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'outlets_list'}" class="float-left mr-1 main-link">{{$t('store.outlets')}}</router-link>
                  <span class="float-left mr-1 main-link">/</span>
                  <router-link :to="{ name: 'outlets_edit',  params: { uuid: uuid }}" class="float-left mr-1 main-link">{{$t('store.details')}}</router-link>
                  / {{$t('store.menu_control')}}
                </h3>
              </strong>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card class="header mb-0" header-tag="header" footer-tag="footer">
            <div slot="header" class="d-flex align-items-center w-100" @click="basicInformationStatus = !basicInformationStatus" style="cursor: pointer;">
              <strong class="text-uppercase mr-auto">{{ $t('store.outlets') }}</strong>
              <i :class="`fa ${!basicInformationStatus ? 'fa-sort-up mt-1' : 'fa-sort-down mb-1'}`"></i>
            </div>
            <b-collapse :visible.sync="basicInformationStatus" id="basic_information_content">
              <b-form class="row" v-if="outletInfo">
                <b-col cols="12">
                  <!-- Store name -->
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label"><strong>{{$t('store.outlet_name')}}</strong></legend>
                    <div class="col-sm-5">
                      <legend class="col-form-label">{{outletInfo.name[$session.get('lang') || 'en']}}</legend>
                    </div>
                  </div>
                  <hr>
                  <!-- Store code -->
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label"><strong>{{$t('store.outlet_code')}}</strong></legend>
                    <div class="col-sm-5">
                      <legend class="col-form-label">{{outletInfo.code}}</legend>
                    </div>
                  </div>
                  <hr>
                  <!-- Owner Name -->
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label"><strong>{{$t('store.owner_name')}}</strong></legend>
                    <div class="col-sm-5">
                      <legend class="col-form-label">{{outletInfo.owner_name}}</legend>
                    </div>
                  </div>
                  <hr>
                  <!-- Owner Code -->
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label"><strong>{{$t('store.owner_code')}}</strong></legend>
                    <div class="col-sm-5">
                      <legend class="col-form-label">{{outletInfo.owner_code}}</legend>
                    </div>
                  </div>
                  <hr>
                  <!-- Address -->
                  <div class="form-group row mb-0">
                    <legend class="col-sm-2 col-form-label"><strong>{{$t('store.address')}}</strong></legend>
                    <div class="col-sm-5">
                      <legend class="col-form-label">{{outletInfo.address[$session.get('lang') || 'en']}}</legend>
                    </div>
                  </div>
                </b-col>
              </b-form>
            </b-collapse>
            <div slot="footer">
              <router-link :to="{ name: 'outlets_list', query: {rollback: 1}}" class="btn border-radius-4px bg-main float-left ml-4"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</router-link>
              <div class="btn-save" v-if="checkPermission($auth.user(),'post.v1.product-menu-be.menu-outlets')">
                <button type="button" class="btn bg-main border-radius-4px pl-3 pr-3" :disabled="!enableSave" @click="pushFirstAndSecondOutOfStock"> {{$t('common.save')}}</button>
              </div>
            </div>
          </b-card>
          <!-- Size Out of Stock -->
          <b-card class="mb-0">
            <div slot="header" class="d-flex align-items-center w-100" @click="sizeStatus = !sizeStatus" style="cursor: pointer;">
              <strong class="text-uppercase mr-auto">{{ $t('store.size_out_of_stock') }}</strong>
              <i :class="`fa ${!sizeStatus ? 'fa-sort-up mt-1' : 'fa-sort-down mb-1'}`"></i>
            </div>
            <b-collapse :visible.sync="sizeStatus" id="size_content">
              <b-row>
                <b-col cols="12">
                  <div class="rectangle-9-copy">
                    <div class="table-responsive table-has-reason">
                      <table class="table table-sm header-pointer table-bordered">
                        <thead class="table-thead">
                        <tr>
                          <th class="thead-th" width="100">
                            {{$t('store.exclusion_target')}}
                          </th>
                          <th scope="col" class="thead-th" width="200">
                            {{$t('store.code')}}
                          </th>
                          <th scope="col" class="thead-th">
                            {{$t('store.name')}}
                          </th>
                          <th v-if="isShowReason()" scope="col" class="thead-th col-200w">
                            {{$t('store.reason')}}
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in dataFirst" :key="index">
                          <td class="text-center">
                            <b-form-checkbox class="checkbox-warning" v-model="item.value" value="1" unchecked-value="0" @change="enableSave = true"></b-form-checkbox>
                          </td>
                          <td>
                            <span>{{item.sku}}</span>
                          </td>
                          <td>
                            <span>{{item.name[$session.get('lang') || 'en']}}</span>
                          </td>
                          <td v-if="isShowReason()" :class="{'combobox-require': !item.reason_uuid}">
                            <b-form-select v-if="item.value == 1" v-model="item.reason_uuid" :options="reasonOptions[$session.get('lang') || 'en']" @change="enableSave = true">
                            </b-form-select>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>

          <!-- Crust Out of Stock -->
          <b-card class="mb-0">
            <div slot="header" class="d-flex align-items-center w-100" @click="crustStatus = !crustStatus" style="cursor: pointer;">
              <strong class="text-uppercase mr-auto">{{ $t('store.crust_out_of_stock') }}</strong>
              <i :class="`fa ${!crustStatus ? 'fa-sort-up mt-1' : 'fa-sort-down mb-1'}`"></i>
            </div>
            <b-collapse :visible.sync="crustStatus" id="crust_content">
              <b-row>
                <b-col cols="12">
                  <div class="rectangle-9-copy">
                    <div class="table-responsive table-has-reason">
                      <table class="table table-sm header-pointer table-bordered">
                        <thead class="table-thead">
                        <tr>
                          <th class="thead-th" width="100">
                            {{$t('store.exclusion_target')}}
                          </th>
                          <th scope="col" class="thead-th" width="200">
                            {{$t('store.code')}}
                          </th>
                          <th scope="col" class="thead-th">
                            {{$t('store.name')}}
                          </th>
                          <th v-if="isShowReason()" scope="col" class="thead-th col-200w">
                            {{$t('store.reason')}}
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in dataSecond" :key="index">
                          <td class="text-center">
                            <b-form-checkbox class="checkbox-warning" v-model="item.value" value="1" unchecked-value="0" @change="enableSave = true"></b-form-checkbox>
                          </td>
                          <td>
                            <span>{{item.sku}}</span>
                          </td>
                          <td>
                            <span>{{item.name[$session.get('lang') || 'en']}}</span>
                          </td>
                          <td v-if="isShowReason()" :class="{'combobox-require': !item.reason_uuid}">
                            <b-form-select v-if="item.value == 1" v-model="item.reason_uuid" :options="reasonOptions[$session.get('lang') || 'en']" @change="enableSave = true">
                            </b-form-select>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>

          <!-- Size & Crust Out of Stock -->
          <b-card class="mb-0">
            <div slot="header" class="d-flex align-items-center w-100" @click="sizeAndCrustStatus = !sizeAndCrustStatus" style="cursor: pointer;">
              <strong class="text-uppercase mr-auto">{{ $t('store.size_crust_out_of_stock') }}</strong>
              <i :class="`fa ${!sizeAndCrustStatus ? 'fa-sort-up mt-1' : 'fa-sort-down mb-1'}`"></i>
            </div>
            <b-collapse :visible.sync="sizeAndCrustStatus" id="size_crust_content">
              <b-row>
                <b-col cols="12">
                  <div class="rectangle-9-copy">
                    <div class="table-responsive table-has-reason">
                      <table class="table table-sm header-pointer table-bordered">
                        <thead class="table-thead">
                        <tr>
                          <th class="thead-th" width="100">
                            {{$t('store.exclusion_target')}}
                          </th>
                          <th scope="col" class="thead-th" width="200">
                            {{$t('store.size_name')}}
                          </th>
                          <th scope="col" class="thead-th">
                            {{$t('store.crust_name')}}
                          </th>
                          <th  v-if="isShowReason()" scope="col" class="thead-th col-200w">
                            {{$t('store.reason')}}
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in dataFirstSecond" :key="index">
                          <td class="text-center">
                            <span>
                              <b-form-checkbox class="checkbox-warning" v-model="item.value" value="1" unchecked-value="0" @change="enableSave = true"></b-form-checkbox>
                            </span>
                          </td>
                          <td>
                            <span>{{item.first && item.first.name[$session.get('lang') || 'en']}}</span>
                          </td>
                          <td>
                            <span>{{item.second && item.second.name[$session.get('lang') || 'en']}}</span>
                          </td>
                          <td v-if="isShowReason()" :class="{'combobox-require': !item.reason_uuid}">
                            <b-form-select v-if="item.value == 1" v-model="item.reason_uuid" :options="reasonOptions[$session.get('lang') || 'en']" @change="enableSave = true">
                            </b-form-select>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>

          <!-- Menu Out of Stock -->
          <b-card class="mb-0" v-if="(outletConfig.config && (typeof outletConfig.config.show_menu_out_of_stock === 'undefined' || outletConfig.config.show_menu_out_of_stock !== false))">
            <div slot="header" class="d-flex align-items-center w-100" @click="commonStatus = !commonStatus" style="cursor: pointer;">
              <strong class="text-uppercase mr-auto">{{ $t('store.menu_out_of_stock') }}</strong>
              <i :class="`fa ${!commonStatus ? 'fa-sort-up mt-1' : 'fa-sort-down mb-1'}`"></i>
            </div>
            <b-collapse :visible.sync="commonStatus" id="customise_content">
              <!-- <b-row v-if="isNzMarket" class="reactivate-menu">
                <b-col cols="12">
                  <span > {{ $t('store.reactivate_menu') }} </span>
                </b-col>
              </b-row> -->
              <b-row>
                <b-col cols="6">
                  <b-form-group v-bind:label="$t('store.topping_out_of_stock')" :label-cols="4" :horizontal="true">
                    <button id="topping_out_of_stock_btn" class="btn bg-main border-radius-4px" @click="goToEditToppingOutOfStock" type="button" >{{$t('common.edit')}}</button>
                  </b-form-group>
                  <b-form-group v-bind:label="$t('store.menu_out_of_stock')" :label-cols="4" :horizontal="true">
                    <button id="menu_out_of_stock_btn" class="btn bg-main border-radius-4px" @click="goToEditMenuOutOfStock" type="button" >{{$t('common.edit')}}</button>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import cSwitch from '../../../components/Switch'
  import vSelect from 'vue-select'
  import Tables from '../../tables/Tables'
  import Multiselect from 'vue-multiselect'

  export default {
    name: 'OutletOutOfStock',
    props: {
      uuid: {
        type: String
      }
    },
    components: {
      Tables,
      cSwitch,
      vSelect,
      Multiselect
    },
    data: function () {
      return {
        languages: this.$store.getters.languages,
        outletConfig: this.$store.getters.config.gms.outlet,
        isNzMarket: false,
        basicInformationStatus: true,
        commonStatus: true,
        sizeStatus: true,
        crustStatus: true,
        sizeAndCrustStatus: true,
        processing: false,
        outletInfo: {
          name: '',
          code: '',
          owner_name: '',
          owner_code: '',
          address: ''
        },
        dataFirst: [],
        dataSecond: [],
        dataFirstSecond: [],
        reasonOptions: {},
        enableSave: false
      }
    },
    mixins: [
      validationMixin
    ],
    created () {
      this.isNzMarket = localStorage.getItem('clientID') === this.client_uuid.nz
    },
    mounted () {
      if (this.$route.params.uuid) {
        this.getDataReason()
        this.getStoreInfo(this.$route.params.uuid)
      }
    },
    methods: {
      checkPermission(userInfo, permission) {
        let modules = userInfo.modules ? userInfo.modules : {}
        let adminIds = [1, 34, 35, 62]
        return adminIds.indexOf(userInfo.user_id) !== -1 || modules.indexOf(permission) !== -1;
      },
      getStoreInfo (uuid) {
        const vm = this
        vm.axios.outlet.getOutletDetail(uuid, response => {
          if (response.status === 200) {
            let data = response.data.data.item
            vm.outletInfo.name = data.name
            vm.outletInfo.code = data.code
            vm.outletInfo.owner_name = data.owner_name
            vm.outletInfo.owner_code = data.owner_code
            vm.outletInfo.address = data.address
            vm.getDataSizeCrust()
          }
        }, error => {
          console.log('error', error)
        })
      },
      getDataReason () {
        const vm = this
        vm.axios.menu.getListReasonStatus(`page=1&limit=500&sort_field=id&sort_type=asc`, response => {
          if (response.status === 200) {
            const data = vm.getValueFromAttr(response, 'data.data.items', [])
            for (let i = 0; i < vm.languages.length; i++) {
              const language = vm.languages[i];
              vm.reasonOptions[language] = [];
              data.forEach(item => {
                vm.reasonOptions[language].push({
                  value: vm.getValueFromAttr(item, `uuid`, null),
                  text: vm.getValueFromAttr(item, `name.${language}`, null),
                  disabled: !vm.getValueFromAttr(item, `active`, false)
                })
              });
            }
          }
        }, error => {
          console.log('error', error)
        })
      },
      getDataSizeCrust () {
        const vm = this
        vm.dataFirstSecond = []
        vm.dataFirst = []
        vm.dataSecond = []
        this.axios.menu.listFirstAndSecondOutOfStock(this.outletInfo.code, function (response) {
          const data = response.data.data.items
          vm.enableSave = false
          vm.dataFirst = data.first_layers || []
          vm.dataSecond = data.second_layers || []
          vm.dataFirst.forEach(first => {
            first.initialValue = first.value
            if (first.second_layers && first.second_layers.length > 0) {
              first.value = 0
              first.initialValue = 0
              first.reason_uuid = ''
            }
            vm.dataSecond.forEach(second => {
              second.initialValue = second.value
              const obj = vm.getObjectInArrs(`second_${second.id}`, first.second_layers || [], 'uuid')
              if (obj) {
                vm.dataFirstSecond.push({
                  first,
                  second,
                  value: 1,
                  initialValue: 1,
                  reason_uuid: obj.reason_uuid
                })
              } else {
                vm.dataFirstSecond.push({
                  first,
                  second,
                  value: 0,
                  initialValue: 0,
                  reason_uuid: ''
                })
              }
            })
          })
        })
      },
      isShowReason () {
        return this.outletConfig.config && this.outletConfig.config.show_reason || false
      },
      checkRequireReason () {
        for (let i = 0; i < this.dataFirst.length; i++) {
          const element = this.dataFirst[i];
          if (Number(element.value) === 1 && !element.reason_uuid) {
            return true
          }
        }
        for (let i = 0; i < this.dataSecond.length; i++) {
          const element = this.dataSecond[i];
          if (Number(element.value) === 1 && !element.reason_uuid) {
            return true
          }
        }
        for (let i = 0; i < this.dataFirstSecond.length; i++) {
          const element = this.dataFirstSecond[i];
          if (Number(element.value) === 1 && !element.reason_uuid) {
            return true
          }
        }
        return false
      },
      goToEditMenuOutOfStock () {
        this.$router.push({name: 'new_menu_out_of_stock', params: {uuid: this.$route.params.uuid}})
      },
      goToEditToppingOutOfStock () {
        this.$router.push({name: 'topping_out_of_stock', params: {uuid: this.$route.params.uuid}})
      },
      pushFirstAndSecondOutOfStock () {
        const vm = this
        if (!vm.enableSave) {
          return
        }
        if (vm.checkRequireReason()) {
          vm.$toastr.error(vm.$t('message.validate_reason'), vm.$t('message.error'), {})
          return
        }
        const params = {
          layers: []
        }
        const arrsFirst = []
        const arrsSecond = []
        this.dataFirst.forEach(element => {
          console.log(element)
          if (Number(element.initialValue) === 1 || Number(element.value) === 1) {
            params.layers.push({
              uuid: `first_${element.id}`,
              sku: element.sku,
              value: Number(element.value),
              reason_uuid: Number(element.value) === 1 ? element.reason_uuid : ''
            })
          }
          if (Number(element.value) === 1) {
            arrsFirst.push(element.id)
          } 
        });
        this.dataSecond.forEach(element => {
          if (Number(element.initialValue) === 1 || Number(element.value) === 1) {
            params.layers.push({
              uuid: `second_${element.id}`,
              sku: element.sku,
              value: Number(element.value),
              reason_uuid: Number(element.value) === 1 ? element.reason_uuid : ''
            })
          }
          if (Number(element.value) === 1) {
            arrsSecond.push(element.id)
          }
        });
        const arrsFirstSecond = []
        this.dataFirstSecond.forEach(element => {
          if ((Number(element.value) === 1 || Number(element.initialValue) === 1) && !arrsFirst.includes(element.first.id) && !arrsSecond.includes(element.second.id)) {
            let obj = this.getObjectInArrs(`first_${element.first.id}`, arrsFirstSecond, 'uuid')
            if (!obj) {
              obj = {
                uuid: `first_${element.first.id}`,
                sku: element.first.sku,
                value: Number(element.value),
                reason_uuid: element.reason_uuid
              }
              arrsFirstSecond.push(obj)
            }
            if (Number(element.value) === 1) {
              obj.value = 1
              if (!obj.second_layers) {
                obj.second_layers = []
              }
              obj.second_layers.push({
                uuid: `second_${element.second.id}`,
                sku: element.second.sku,
                reason_uuid: element.reason_uuid
              })
            }
          }
        });
        params.layers = params.layers.concat(arrsFirstSecond)
        if (params.layers.length === 0) {
          vm.$toastr.error(vm.$t('store.msg_save_out_of_stock'), '', {})
          return
        }
        vm.axios.menu.pushFirstAndSecondOutOfStock(this.outletInfo.code, params, function (response) {
          vm.getDataSizeCrust()
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.update_successful'), {})
        }, function (data) {
          // vm.$toastr.error(vm.$t('message.error'), vm.$t('message.error'), {})
        })
      }
    }
  }
</script>

<style scoped>
  .menu-group-form .switch.switch-icon{
    margin-top: 5px;
  }

  .menu-group-form .header-custom-switch{
    margin-top: 5px;
    margin-bottom: 0;
  }

  .menu-group-form .header-custom-switch .col-form-label{
    text-align: right;
  }

  .menu-group-form .header-custom-switch .uppercase{
    display: inline-flex;
  }

  .menu-group-form .header-custom-switch .uppercase .first{
    margin-right: 10px;
  }

  .menu-group-form .header-custom-switch .uppercase .last{
    margin-left: 10px;
  }
</style>

<style>
  .menu-group-form .switch-success > .switch-input:checked ~ .switch-label,
  .menu-group-form .btn-success,
  .menu-group-form .btn-primary{
    background: #0086FF !important;
    border-color: #0086FF !important;
  }

  .menu-group-form .btn-save{
    float: right;
    margin-right: 22px;
  }

  .menu-group-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }

  .menu-form .btn-save {
    float: right;
    margin-right: 22px;
  }

  .menu-form .card-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }

  .menu-form div.header,
  .menu-form .header .card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  .rectangle-9-copy {
    width: auto;
    border: 1px solid #E1E6EB;
    border-radius: 3px;
    background-color: #F5F7F9;
  }

  .rectangle-9-copy-header {
    height: 49px;
    width: auto;
    border-radius: 3px 3px 0 0;
    background-color: #E1E6EB;
  }

  .table-thead {
    background-color: #c3cbd4;
  }

  #menu_out_of_stock_btn, #topping_out_of_stock_btn {
    width: 150px;
  }

  .col-200w {
    width: 200px;
  }

  .reactivate-menu {
    margin-bottom: 20px;
    color: #ff5630;
  }

  .combobox-require select {
    border-color: red;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/outlets/OutletOutOfStock.vue